const data = {
  "width": 48,
  "height": 48,
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"4\" d=\"M4 24c0 11.046 8.954 20 20 20s20-8.954 20-20S35.046 4 24 4\"/>"
};
exports.__esModule = true;
exports.default = data;